<template>
    <div ref="wrap" :class="['search-select', {'widen': isWiden, 'is-focus': input.focus}]" @click="handleWrapClick">
        <div
            class="search-input"
            :style="{ maxHeight: (shrink ? (input.focus ? maxHeight : minHeight) : maxHeight) + 'px' }">
            <div
                :class="['select-tags', {'active': item.isSelect}]"
                v-for="(item, index) in searchSelectValue"
                :key="index"
                @click.stop="onClickSelectTag(item.id, item.values)">
                <el-popover
                    ref="selectPopover"
                    placement="bottom"
                    popper-class="select-list-popover"
                    trigger="click"
                    :value="item.isSelect"
                    @hide="handleSelectPopHidden(item.id)">
                    <div slot="reference">
                        <span>{{ item.name + '：'}}</span>
                        <span class="val-item" v-for="(val, idx) in item.values" :key="idx">
                            {{ val }}
                            <span class="separation-line" v-if="idx !== item.values.length - 1"></span>
                        </span>
                        <i @click.stop="onClearSelectTag(item.id)" class="el-icon-close"></i>
                    </div>
                    <ul>
                        <li 
                            v-for="(val, valIndex) in item.values"
                            :key="valIndex"
                            class="select-list-menu-item"
                            @click="onClearSelectTag(item.id, val)">
                            {{ val }}
                            <i class="el-icon-check" v-if="selectValues.includes(val)"></i>
                        </li>
                    </ul>
                    <div class="select-list-footer">
                        <span class="footer-btn" @click="handleConfirm(item.id)">确定</span>
                        <span class="footer-btn" @click="handleSelectPopHidden(item.id, true)">取消</span>
                    </div>
                </el-popover>
            </div>
            
            <div class="search-input-input">
                <div
                    ref="input"
                    class="div-input"
                    :class="{ 'input-before': isShowPlaceholder}"
                    contenteditable="plaintext-only"
                    :data-placeholder="placeholder"
                    @click="handleInputClick"
                    @focus="handleInputFocus"
                    @blur="handleInputBlur"
                    @input="handleInputChange"
                    @keydown="handleInputKeyup">
                </div>
                <el-popover
                    placement="bottom"
                    popper-class="search-list-popover"
                    trigger="manual"
                    v-model="visible"
                    @hidden="handleSeachPopHidden">
                    <span slot="reference" class="search-list-menu"></span>
                    <div ref="tagPopover" class="search-list-content" v-if="selectInfo && selectInfo.id === 'tag'" v-loading="isTagsLoading">
                        <el-input
                            class="tag-input"
                            placeholder="请输入内容"
                            v-model="tagText"
                            @change="onTagsInputChange">
                            <img slot="prefix" src="../../images/community/search.png">
                        </el-input>
                        <ul class="tag-content" ref="tagList">
                            <li
                                v-for="(item, index) in tagsList"
                                :key="index"
                                class="tag-content-menu-item"
                                @click="onSelectTags(item.title)">
                                {{ item.title }}
                                <i class="el-icon-check" v-if="selectTagList.includes(item.title)"></i>
                            </li>
                            <li class="tag-content-menu-item scroll-loading" v-if="isLoading" v-loading="true"></li>
                            <li v-if="!tagsList.length && !isTagsLoading" class="data-null">暂无数据</li>
                        </ul>
                        <div class="tag-content-footer" v-show="tagsList.length">
                            <span class="footer-btn" @click="handleSelectTagsConfirm">确定</span>
                            <span class="footer-btn" @click="handleSeachPopHidden">取消</span>
                        </div>
                    </div>
                    
                    <ul v-else class="search-list-menu">
                        <template v-for="(item, index) in searchList">
                            <li
                                :key="index"
                                v-if="item.isShow"
                                :class="['search-list-menu-item', {'active': item.id === selectInfo.id}]"
                                @click="onSelect(item)">
                                {{ item.name }}
                            </li>
                        </template>
                    </ul>
                </el-popover>
            </div>   
        </div>
        <span v-if="input.value || searchSelectValue.length" @click.stop="handleClear" :class="['close-icon', { 'is-close': input.value}]"></span>
        <span v-else @click.stop="handleKeyEnter" :class="['search-icon', {'is-focus': input.focus}]"></span>
    </div>
    
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        searchSelectValue: {
            type: Array,
            default: () => []
        },
        maxHeight: {
            type: [String, Number],
            default: 120
        },
        minHeight: {
            type: [String, Number],
            default: 30
        },
        shrink: {
            type: Boolean,
            default: true
        },
        isSearch: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            searchList: [{
                id: 'text',
                name: '关键字',
                isShow: true,
                values: []
            }, {
                id: 'tag',
                name: '标签',
                isShow: true,
                values: []
            }, {
                id: 'name',
                name: '用户',
                isShow: true,
                values: []
            }],
            visible: false,
            selectInfo: {},
            input: {
                value: '',
                focus: false
            },
            isTagsLoading: true,
            tagsList: [],
            tagText: '',
            isLoading: false,
            isThrottled: false, // 滚动节流 是否进入cd
            isPageOver: false, // 前端分页加载是否结束
            totalPage: null, // 计算出总共多少页
            page: 0, // 当前加载了多少页
            selectValues: [],
            isOutSide: false,
            isCancel: false,
            selectTagList: []
        }
    },
    computed: {
        isWiden () {
            return this.input.value ||
                this.visible ||
                this.searchSelectValue.length ||
                Object.keys(this.selectInfo).length
        },
        isShowPlaceholder () {
            return !this.searchSelectValue.length &&
                !this.input.value.length &&
                !Object.keys(this.selectInfo).length
        }
    },
    mounted () {
        window.addEventListener('mouseup', this.handleInputOutSide)
        // 根据传进来的searchSelectValue更新searchList
        const index = this.searchSelectValue.findIndex(item => item.id === 'text')
        if (index > -1) {
            this.setSearchList(false)
        }
    },
    beforeDestroy() {
        window.removeEventListener('mouseup', this.handleInputOutSide)
        if (this.ulScroller) {
            this.ulScroller.removeEventListener('scroll', this.handleUlScroll)
        }
    },
    methods: {
        // 滚动加载
        handleUlScroll () {
            if (!this.isPageOver && !this.isThrottled && !this.isLoading) {
                this.isThrottled = true
                this.pollingTimer = setTimeout(() => {
                    this.isThrottled = false
                    const el = this.ulScroller
                    if (el.scrollHeight - el.offsetHeight - el.scrollTop < 10) {
                        this.page++
                        clearTimeout(this.pollingTimer)
                        this.isLoading = true
                        if (this.tagText) {
                            this.getTagList(this.tagText)
                        } else {
                            this.getTagList()
                        }
                    }
                }, 200)
            }
        },
        // 获取标签
        async getTagList (keyword) {
            try {
                const params = keyword ? `page_size=10&page=${this.page}&keyword=${keyword}` : `page_size=10&page=${this.page}`
                await axios.get(myUrl + `forum/tag/?${params}`).then((res) => {
                    if (res.data.result) {
                        const resp = res.data.data
                        if (keyword !== undefined) {
                            this.tagsList = resp.results
                        } else {
                            this.tagsList.push(...resp.results)
                        }
                        this.totalPage = Math.ceil(resp.count / 10)
                        this.isPageOver = this.page >= this.totalPage
                    }
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.isTagsLoading = false
                this.isLoading = false
            }
        },
        // 搜索标签
        onTagsInputChange () {
            this.page = 1
            this.isTagsLoading = true
            this.getTagList(this.tagText)
        },
        // 点击已生成的selectTag
        onClickSelectTag (id, values) {
            this.searchSelectValue.forEach(item => {
                item.isSelect = item.id === id
            })
            this.selectValues = JSON.parse(JSON.stringify(values))
            setTimeout(() => {
                this.visible = false
            }, 100)
            this.input.focus = true
        },
        // 确定修改已生成的tag
        handleConfirm (id) {
            const index = this.searchSelectValue.findIndex(item => item.id === id)
            const selectContent = this.searchSelectValue[index]
            // 如果没有修改则不更新
            if (selectContent.values.length !== this.selectValues.length) {
                selectContent.values = this.selectValues
                if (!selectContent.values.length) {
                    this.searchSelectValue.splice(index, 1)
                }
                if (id === 'text') {
                    this.setSearchList(true)
                }
                this.$emit('onClearSelectTag', id, this.selectValues)
            }
            this.selectValues = []
            selectContent.isSelect = false
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
            this.$emit('change', this.searchSelectValue)
        },
        // 已生成tag的popover消失事件
        handleSelectPopHidden (id, isCancel) {
            const index = this.searchSelectValue.findIndex(item => item.id === id)
            const selectContent = this.searchSelectValue[index]
            selectContent.isSelect = false
            if (isCancel) {
                this.$refs.input.focus()
            }
        },
        // 修改已生成的tag
        onClearSelectTag (id, val) {
            if (!val) {
                const index = this.searchSelectValue.findIndex(item => item.id === id)
                this.searchSelectValue.splice(index, 1)
                if (id === 'text') {
                    this.setSearchList(true)
                }
                this.$nextTick(() => {
                    this.$refs.input.focus()
                })
                this.$emit('onClearSelectTag', id)
                this.$emit('change', this.searchSelectValue)
            } else {
                const valIndex = this.selectValues.findIndex(item => item === val)
                if (valIndex > -1) {
                    this.selectValues.splice(valIndex, 1)
                } else {
                    this.selectValues.push(val)
                }
            }
        },
        setSearchList (show) {
            this.searchList.forEach(item => {
                if (item.id === 'text') {
                    item.isShow = show
                }
            })
        },
        // 选择标签
        onSelectTags (val) {
            const valIndex = this.selectTagList.findIndex(item => item === val)
            if (valIndex > -1) {
                this.selectTagList.splice(valIndex, 1)
            } else {
                this.selectTagList.push(val)
            }
        },
        handleSelectTagsConfirm () {
            if (!this.isSearch) {
                this.goSearch()
                return
            }
            const searchContent = this.searchSelectValue.find(item => item.id === 'tag')
            if (searchContent) {
                searchContent.values = JSON.parse(JSON.stringify(this.selectTagList))
            } else {
                this.searchSelectValue.push({
                    id: 'tag',
                    name: '标签',
                    isShow: true,
                    values: JSON.parse(JSON.stringify(this.selectTagList))
                })
            }
            this.$emit('change', this.searchSelectValue)
            this.tagText = ''
            this.selectTagList = []
            this.tagsList = []
            this.$refs.input.innerText = ''
            this.selectInfo = {}
            this.$refs.input.focus()
            this.visible = false
            setTimeout(() => {
                this.visible = true
            }, 300)
        },
        // 搜索列表popover消失事件
        handleSeachPopHidden () {
            this.tagText = ''
            this.selectTagList = []
            this.tagsList = []
            this.isCancel = true
            this.$refs.input.focus()
            this.$nextTick(() => {
                this.visible = false
            })
        },
        // 选中标题类型
        onSelect (val) {
            this.selectInfo = JSON.parse(JSON.stringify(val))
            const inputDom = this.$refs.input
            inputDom.innerText = val.name + '：'
            // 输入框获取焦点
            inputDom.focus()
            if (this.selectInfo.id === 'tag') {
                setTimeout(() => {
                    this.ulScroller = this.$refs.tagList
                    if (this.ulScroller) {
                        this.ulScroller.addEventListener('scroll', this.handleUlScroll)
                    }
                }, 300)
            }
        },
        // 点击文本框
        handleInputClick (e) {
            this.input.focus = true
        },
        // 点击到searchSelect外面
        handleInputOutSide (e) {
            const isSelect = this.searchSelectValue.some(item => item.isSelect)
            if (isSelect) return
            let self = this
            const searchSelectDom = this.$refs.wrap
            const tagListDom = this.$refs.tagPopover
            // 点击searchSelect外面/popover外面需要收起
            if ((tagListDom && !tagListDom.contains(e.target)) && (searchSelectDom && !searchSelectDom.contains(e.target))) {
                if (Object.keys(this.selectInfo).length) {
                    self.isOutSide = true
                    self.visible = false
                }
                if (self.input.focus){
                    self.input.focus = Object.keys(this.selectInfo).length
                }
            } else {
                self.input.focus = Object.keys(this.selectInfo).length
                self.isOutSide = false
            }
        },
        setCommonTagList () {
            this.isTagsLoading = true
            this.tagsList = []
            this.tagText = ''
            const searchContent = this.searchSelectValue.find(item => item.id === 'tag')
            if (searchContent) {
                this.selectTagList = JSON.parse(JSON.stringify(searchContent.values))
            }
            this.page = 1
            this.getTagList()
        },
        // 文本框获取焦点
        handleInputFocus () {
            // 等文本框展开后再显示popover
            setTimeout(() => {
                const isSelect = this.searchSelectValue.find(item => item.isSelect)
                if (!Object.keys(this.selectInfo).length && !this.input.value && !isSelect) {
                    this.visible = true
                } else if (this.selectInfo.id === 'tag' && !this.input.value && !this.isCancel) {
                    this.visible = true
                    this.setCommonTagList()
                }
            }, 550)
            this.input.focus = true
            const input = this.$refs.input
            let selection = null
            if (window.getSelection) {
                selection = window.getSelection()
                selection.selectAllChildren(input)
                selection.collapseToEnd()
            } else if (document.onselectionchange) {
                selection = document.onselectionchange.createRange()
                selection.moveToElementText(input)
                selection.collapse(false)
                selection.select()
            }
        },
        // searchSelect点击事件
        handleWrapClick () {
            this.$refs.input.focus()
        },
        // 文本框失去焦点
        handleInputBlur (e) {
            setTimeout(() => {
                let show = false
                if (this.isOutSide && this.selectInfo.id === 'tag') {
                    show = false
                } else if (this.isCancel) {
                    show = false
                } else if (this.selectInfo.id === 'tag') {
                    show = true
                }
                this.visible = show
            }, 200)
        },
        // 文本框内容改变
        handleInputChange (e) {
            this.visible = false
            this.isCancel = false
            this.input.value = text
            let text = e.target.innerText
            const isLength = Object.keys(this.selectInfo).length
            this.input.value = isLength ? text.slice(text.indexOf('：') + 1) : text.trim()
            if (!text) {
                this.selectInfo = {}
                this.visible = true
            }
            if (!this.input.value && this.selectInfo.id === 'tag') {
                this.visible = true
                this.setCommonTagList()
            }
        },
        // 文本框按键事件
        handleInputKeyup (e) {
            switch (e.code) {
                case 'Enter':
                case 'NumpadEnter':
                    this.handleKeyEnter(e)
                    break
                case 'Backspace':
                    this.handleKeyBackspace(e)
                    break
                case 'ArrowDown':
                case 'ArrowUp':
                    e.preventDefault()
                    break
                default:
                    return false
            }
        },
        // 回车按键
        handleKeyEnter (e) {
            e.preventDefault()
            if (!this.isSearch) {
                this.goSearch()
                return
            }
            // setTimeout用在使用中文输入法不空格直接回车时，生成的tag和input.value会同时存在
            setTimeout(() => {
                if (!this.input.value) return
                const isLength = Object.keys(this.selectInfo).length
                const searchTextContent = this.searchSelectValue.find(item => item.id === 'text')
                const idIndex = searchTextContent ? 1 : 0
                const id = isLength ? this.selectInfo.id : this.searchList[idIndex].id
                const index = this.searchSelectValue.findIndex(item => item.id === id)
                if (index > -1) {
                    const selectContent = this.searchSelectValue[index]
                    const isTrue = selectContent.values.some(item => item === this.input.value)
                    if (!isTrue) {
                        selectContent.values.push(this.input.value)
                    }
                } else {
                    const selected = isLength ? this.selectInfo : JSON.parse(JSON.stringify(this.searchList[idIndex]))
                    selected.values.push(this.input.value)
                    this.searchSelectValue.push(selected)
                }
                this.$emit('change', this.searchSelectValue)
                if (id === 'text') {
                    this.setSearchList(false)
                }

                this.input.value = ''
                this.$refs.input.innerText = ''
                this.selectInfo = {}
                this.visible = true
            }, 0)
        },
        // 清空按键
        handleKeyBackspace (e) {
            if (!this.$refs.input.innerText && this.searchSelectValue.length) {
                const length = this.searchSelectValue.length
                const id = this.searchSelectValue[length - 1].id
                this.searchSelectValue.pop()
                if (id === 'text') {
                    this.setSearchList(true)
                }
                this.visible = false
                this.$nextTick(() => {
                    this.visible = true
                })
                this.$emit('onClearSelectTag', id)
                this.$emit('change', this.searchSelectValue)
            }
        },
        // 快速清空
        handleClear () {
            this.$refs.input.innerText = ''
            this.input.value = ''
            this.selectInfo = {}
            if (this.input.focus) {
                this.$nextTick(() => {
                    this.visible = true
                })
            }
            this.setSearchList(true)
            this.$emit('clear')
        },
        // 前往搜索页
        goSearch () {
            let selectTag = this.selectTagList.join(',') || undefined
            if (selectTag) {
                selectTag = encodeURIComponent(selectTag)
            }
            const { value } = this.input
            const { id } = this.selectInfo
            this.$router.push({
                path: '/s-mart/community/search',
                query: {
                    searchText: !id || id === 'text' ? value : undefined,
                    selectTag,
                    nickName: id && id === 'name' ? value : undefined
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/scss/scrollbar.scss';
    .search-select {
        position: relative;
        background: #fff;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 300px;
        font-size: 12px;
        min-height: 30px;
        box-sizing: border-box;
        border: 1px solid #c4c6cc;
        border-radius: 2px;
        outline: none;
        resize: none;
        transition: border 0.2s linear;
        overflow: auto;
        color: #63656e;
        flex-wrap: wrap;
        @include scrollbar;
        padding-right: 25px;

        &.widen, &:focus-within {
            width: 504px;
        }
        &.is-focus {
            border-color: #3c96ff;
        }
        transition: all .5s;
    }
    .search-input {
        flex: 1;
        position: relative;
        padding: 0 2px 4px;
        text-align: left;
        overflow: visible;
        display: flex;
        flex-wrap: wrap;
        min-height: 26px;
        transition: max-height .3s cubic-bezier(0.4, 0, 0.2, 1);
        
        .select-tags {
            margin: 4px 0 0 5px;
            padding: 0 5px;
            min-height: 22px;
            line-height: 22px;
            background: #f0f1f5;
            border-radius: 2pt;
            display: flex;
            align-items: center;
            color: #63656e;
            cursor: pointer;
            &.active, &:hover {
                background: #dcdee4;
            }
            .val-item {
                margin-right: 15px;
                position: relative;
                .separation-line {
                    width: 1px;
                    height: 12px;
                    background: #63656e;
                    display: inline-block;
                    position: relative;
                    top: 2px;
                    left: 8px;
                }
                &:nth-last-child(2) {
                    margin-right: 0;
                    &::after {
                        content: '';
                        display: none !important;
                    }
                }
            }
            .el-icon-close {
                color: #979ba5;
                font-size: 13px;
                margin: 0 4px;
                font-weight: 700;
            }
        }
        .search-input-input {
            position: relative;
            padding: 0 8px;
            color: #63656e;
            flex: 1 1 auto;
            border: none;
            min-width: 40px;
            display: flex;
            align-items: center;
            .div-input {
                flex: 1 1 auto;
                line-height: 22px;
                padding-top: 4px;
                word-break: break-all;
                position: relative;
                border: none;
                &:focus {
                    outline: none;
                }
            }
            .input-before {
                &:before {
                    content: attr(data-placeholder);
                    color: #c4c6cc;
                    padding-left: 2px;
                }
            }
            .search-list-menu {
                position: absolute;
                top: 18px;
                left: 10px;
                bottom: 0;
                transform: scale(0);
                width: 100px;
            }
        }
    }
    
    .search-icon, .close-icon {
        position: absolute;
        top: 8px;
        right: 5px;
        height: 14px;
        width: 14px;
        display: inline-block;
        cursor: pointer;
    }
    .search-icon {
        background: url('../../images/community/search.png');
        background-size: 100% 100%;
        &.is-focus {
            background: url('../../images/community/search2.png');
            background-size: 100% 100%;
        }
    }
    .close-icon {
        background: url('../../images/community/close-circle-shape.png');
        background-size: 100% 100%;
        &:hover {
            background: url('../../images/community/close-circle-shape2.png');
            background-size: 100% 100%;
        }
    }
</style>
<style lang="scss">
    @import '@/scss/scrollbar.scss';
    .search-list-popover, .select-list-popover {
        min-width: 100px !important;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10);
        padding: 6px 0;
    }
    .search-list-menu-item, .select-list-menu-item, .tag-content-menu-item {
        height: 32px;
        line-height: 32px;
        color: #63656e;
        padding-left: 15px;
        cursor: pointer;
        font-size: 12px;
        &.active, &:hover {
            background: #e1ecff;
            color: #3a84ff;
        }
    }
    .search-list-popover {
        padding: 0 !important;
        .search-list-content {
            min-height: 283px;
        }
        .search-list-menu {
            width: 100px;
            .search-list-menu-item {
                &:first-child {
                    margin-top: 6px;
                }
                &:last-child {
                    margin-bottom: 6px;
                }
            }
        }
        .popper__arrow {
            display: none !important;
        }
    }
    .select-list-popover, .search-list-popover .tag-content {
        min-width: 200px !important;
        padding-bottom: 0 !important;
        .select-list-menu-item, .tag-content-menu-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 15px;
            .el-icon-check {
                color: #3a84ff;
                font-size: 16px;
                font-weight: 700;
                margin-left: 10px;
            }
        }
    }
    .select-list-footer, .tag-content-footer {
        display: flex;
        line-height: 32px;
        justify-content: space-around;
        align-items: center;
        font-size: 12px;
        .footer-btn {
            flex: 1;
            text-align: center;
            border-top: 1px solid #dcdee5;
            cursor: pointer;
            &:first-child {
                border-right: 1px solid #dcdee5;
            }
            &:hover {
                background: #e1ecff;
                color: #3a84ff;
            }
        }
    }
    .search-list-popover .tag-content, .select-list-popover > ul {
        margin-bottom: 32px;
        max-height: 250px;
        overflow: auto;
        min-width: 250px !important;
        @include scrollbar;
        .data-null {
            text-align: center;
            padding: 90px 0;
            color: #979ba5;
        }
    }
    .search-list-popover {
        .tag-input {
            margin: 0 6px;
            border-bottom: 1px solid #dcdee5;
            width: 238px;
            .el-input__inner {
                border: none;
                font-size: 12px;
                height: 32px;
                border-radius: 0;
            }
            img {
                height: 14px;
                width: 14px;
                margin-top: 10px;
            }
        }
        .scroll-loading {
            .el-loading-spinner {
                margin-top: -10px !important;
                .circular {
                    height: 20px !important;
                    width: 20px !important;
                }
            }
        }
    }
    .tag-content-footer, .select-list-footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// searchSelect.vue?480e4082